module.exports = __webpack_public_path__ + "static/media/logo.dc470c03.svg";